if (!customElements.get('custom-swatch-slider')) {
  class CustomSwatchSlider extends HTMLElement {
    constructor() {
      super();

      this.initSlider();

      window.addEventListener('shopify:section:load', () => {
        this.initSlider();
      });
    }

    initSlider() {
      const swiperEl = this.querySelector('.custom-swatch-swiper');
      const scrollbarEl = this.querySelector('.custom-swatch-scrollbar');
      if (!swiperEl) return;

      this.slider = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });
    }
  }

  customElements.define('custom-swatch-slider', CustomSwatchSlider);
}
